import {daysShort, daysShortEn, daysLong, daysLongEn, monthsLongEn, monthsLong,
  monthsShort, monthsShortEn} from "./dateStructs"

export function getWeekdayShort(dayNum: number, lang: string) {
  if (lang === 'en') {
    return daysShortEn[dayNum]
  }
  return daysShort[dayNum]
}

export function weekdayLongFromDate(date: Date, lang: string) {
  let day = date.getDay() - 1
  if (day < 0) {
    day = 6
  }
  return getWeekdayLong(day, lang)
}

export function getWeekdayLong(dayNum: number, lang: string) {
  if (lang === 'en') {
    return daysLongEn[dayNum]
  }
  return daysLong[dayNum]
}

export function getDateLong(dateStr: string, lang: string) {
  const d = new Date(dateStr)
  return d.getDate() + ' ' + getMonthLong(d.getMonth(), lang) + ', ' + d.getFullYear()
}

export function getDayTime(dateStr: string, lang: string) {
  const d = new Date(dateStr)
  return  weekdayLongFromDate(d, lang) + ' - ' + dateFormatHourMinute(d)
}

export function getMonthLong(monthNum: number, lang: string) {
  if (lang === 'en') {
    return monthsLongEn[monthNum]
  }
  return monthsLong[monthNum]
}

export function getMonthShort(monthNum: number, lang: string) {
  if (lang === 'en') {
    return monthsShortEn[monthNum]
  }
  return monthsShort[monthNum]
}

export function dateFormatHourMinute(d: Date) {
   return d.getHours() + ':' + twoDigits(d.getMinutes())
}

export function addMinutes(d: Date, minutes: number): Date {
  let newDate = new Date(d)
  newDate.setMinutes(newDate.getMinutes() + minutes)
  return newDate
}

export function addDays(d: Date, days: number): Date {
  let newDate = new Date(d)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}

export function calculateEndTime(start: Date, l: number) {
  return new Date(start.getTime() + l * 60000)
}

export function formatHourMinute(dateStr: string) {
  const d = new Date(dateStr)
  return dateFormatHourMinute(d)
}

export function formatCountDown(dateStr: string, lang: string) {
  const d = new Date(dateStr)
  const now = new Date()
  const secondsDiff = (d.getTime() - now.getTime()) / 1000
  const inTime = lang === 'sv' ? 'Om ' : 'In '

  if (secondsDiff > 0 && secondsDiff < 24 * 3600) {
    const hours = Math.floor(secondsDiff / 3600)
    const minutes = Math.floor((secondsDiff - 3600 * hours) / 60)
    const seconds = Math.floor(secondsDiff - 3600 * hours - 60 * minutes)
    if (hours > 0) {
      return inTime + hours + ' h ' + minutes + ' min'
    } else {
      return inTime + minutes + ' min ' + twoDigits(seconds) + ' s'
    }
  } else {
    return "-"
  }

}

export function dateFormatSoon(d: Date, lang: string) {
  const now = new Date()
  const midnight = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const utcDate = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());

  const dayDiff = Math.floor((utcDate - midnight) / (24 * 3600 * 1000));

  let ret: string

  if (now.getFullYear() !== d.getFullYear()) {
    ret = '' + d.getFullYear() + ' ' + d.getDate() + '/' + (d.getMonth() + 1)
  } else if (dayDiff === 0) {
    if (lang === 'en') ret = 'Today'
    else ret = 'I dag'
  } else if (dayDiff === 1) {
    if (lang === 'en') ret = 'Tomorrow'
    else ret = 'I morgon'
  } else if (dayDiff === 2) {
    if (lang === 'en') ret = 'Day after tomorrow'
    else ret = 'I övermorgon'
  } else if (dayDiff === -1) {
    if (lang === 'en') ret = 'Yesterday'
    else ret = 'I går'
  } else {
    let day = lang === 'en' ? daysLongEn : daysLong
    ret = day[dayOfWeek(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1)
  }

  ret += ' ' + d.getHours() + ':' + twoDigits(d.getMinutes())
  return ret
}

export function formatSoon(dateStr: string, lang: string) {
  const d = new Date(dateStr)
  return dateFormatSoon(d, lang)

}

export function isSoon(dateStr: string, minutes: number) {
  const d = new Date(dateStr)
  const now = new Date()

  const minuteDiff = (d.getTime() - now.getTime()) / (60 * 1000);

  if (minuteDiff < minutes) {
    return true
  } else {
    return false
  }
}

export function isSameDate(d1: Date, d2: Date) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

export function minutesToTime(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return hours + ':' + twoDigits(minutes)
}

export function twoDigits(digit: number) {
  if (digit < 10) {
    return "0" + digit
  }
  return "" + digit
}

// Convert orgDate into a date that has the same week as weekDate
export function convertToWeekDate(thisWeekDate: Date, orgDate: Date) {
  // Convert week day so that Monday is 0
  const thisWeekDay = getDayOfWeek(thisWeekDate)
  const orgWeekDay = getDayOfWeek(orgDate)
  // If original day is Wednesday (2) and this day is Tuesday (1), add (2-1=1) day
  const addDays = orgWeekDay - thisWeekDay

  return new Date(
    thisWeekDate.getFullYear(),
    thisWeekDate.getMonth(),
    thisWeekDate.getDate() + addDays,
    orgDate.getHours(),
    orgDate.getMinutes(),
    0
  )
}

export function getDayOfWeek(d: Date) {
  let dayOfWeek = d.getDay() - 1
  if (dayOfWeek < 0) {
    dayOfWeek = 6
  }
  return dayOfWeek
}

export function getWeekFromDate(d: Date) {
  const date = new Date(d.getTime())
  date.setHours(0, 0, 0, 0)
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7)
  // January 4 is always in week 1.
  const week1 = new Date(date.getFullYear(), 0, 4)
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
    - 3 + (week1.getDay() + 6) % 7) / 7)
}

export function zDate(d: Date, lang: string, long: boolean = false) {
  const m = d.getMonth()
  const month = lang === 'sv' ? monthsShort[m].toLowerCase() : monthsShortEn[m]
  let result = d.getDate() + ' ' + month
  if (long) {
    result += ' ' + d.getFullYear()
  }
  return result
}

export function dateFormatDate(d: Date, showTime: boolean, lang: string) {
  let day = lang === 'en' ? daysLongEn : daysLong
  let ret = day[dayOfWeek(d)] + ' ' + d.getDate() + '/' + (d.getMonth() + 1)
  if (showTime) {
    ret += ' ' + twoDigits(d.getHours()) + ':' + twoDigits(d.getMinutes())
  }
  return ret
}

export function formatDate(dateStr: string, showTime: boolean, lang: string) {
  const d = new Date(dateStr)
  return dateFormatDate(d, showTime, lang)
}

export function formatDateMonDay(dateStr: string, lang: string) {
  const d = new Date(dateStr)
  return d.getDate() + '/' + (d.getMonth() + 1)
}

export function dayOfWeek(date: Date) {
  if (date) {
    const dow = date.getDay()
    if (dow === 0) {
      return 6
    } else {
      return dow - 1
    }
  }
  return 0  // Actually an error, but should not happen
}

export function todayStr(today?: Date) {
  if (!today) {
    today = new Date();
  }
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

export function formatYYYYDDMM(d: Date) {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

export function formatDateYear(dateStr: string) {
  const today = new Date(dateStr);
  return formatYYYYDDMM(today)
}
